import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-2",
  "use": "icon-user-2-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-user-2\"><path fill-rule=\"evenodd\" d=\"M6.5 12a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0zM16 5.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z\" clip-rule=\"evenodd\" /><path fill-rule=\"evenodd\" d=\"M16 21.5a12.504 12.504 0 00-10.828 6.25 1.5 1.5 0 01-2.597-1.502 15.506 15.506 0 0126.85 0 1.5 1.5 0 11-2.597 1.501A12.504 12.504 0 0016 21.5z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol